module.exports = __webpack_public_path__ + "img/mobile-legends.b77339c.png";